import React, { useEffect, useMemo, useState } from 'react';
import './ProductDetailNew.scss';
import Pricing from './../../../CommonComponents/ProductCard/Pricing';
import { odPushGA4Event } from '../../../utils/gaFour';
import ProductDetailHeading from './ProductDetailHeading/ProductDetailHeading';
import {
  calculateOptimalPrice,
  getColorOptions,
  isHarryPotterProduct,
  removeDomainName,
} from '../../../own-days/helper';
import { debounce } from '../../../utils/helper';
import ContactLensParams from './SideBarOwnDays/ContactLensParams/ContactLensParams';
import { isGundamProduct } from '../../../own-days/views/desktop/Gundam/gundamHelper';
import ColorOptions from './../../../own-days/CommonComponents/ColorOptions/ColorOptions';
import apiClient from '../../../helpers/apiClient';
import { apiPath } from '../../../config';

const ProductDetailNew = props => {
  const {
    dataLocale,
    productData,
    currencyMark,
    isExchange,
    exchangeFreeText,
    exchangeText,
    frameShape,
    frameType,
    contactLensPowerFromUrl,
    redisCommonData,
    login,
    userInfo,
    localeInfo,
    platform,
    setColorPreviewImageUrl,
    selectContactLensPowersCallback,
    contactLensPackaging,
    contactLensPowers,
  } = props;
  const { frameColour, type } = productData;
  const { PRODUCT_OFFERID_CONFIG_DESKTOP } = redisCommonData || {};

  console.log('product dataaaaa ====>', productData);
  const colorOptions = getColorOptions(productData);

  const [exchangePrice, setExchangePrice] = useState(null);
  const [exchangeMarketPrice, setExchangeMarketPrice] = useState(null);
  const [selectedColor, setSelectedColor] = useState(colorOptions[0]?.colorHex);
  const [showImportantNotesModal, setShowImportantNotesModal] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const currencyCode =
    productData.prices && productData.prices.length > 0
      ? productData.prices[0].currencyCode
      : dataLocale.CURRENCY_CODE;
  const currencySymbol = <span>{currencyMark[currencyCode]}</span>;
  const { COLOUR } = dataLocale;
  const techinalInformation =
    productData !== undefined && productData !== null ? productData.specifications[1].items : '';
  let ftype = null;
  // Frame Type Check
  if (techinalInformation) {
    techinalInformation.map(value => {
      if (value.name === 'Frame Type') {
        ftype = value.value.toLowerCase();
      }
      return ftype;
    });
  }

  let subSelection = 'default';
  if (login) {
    subSelection = userInfo?.result?.hasPlacedOrder ? 'repeat' : 'new';
  }
  const productOfferIdDetails =
    PRODUCT_OFFERID_CONFIG_DESKTOP &&
    PRODUCT_OFFERID_CONFIG_DESKTOP[productData.offerName] &&
    PRODUCT_OFFERID_CONFIG_DESKTOP[productData.offerName][subSelection];

  const marketPrice = productData.prices[0].price;
  const CURRENCY_CODE = dataLocale?.CURRENCY_CODE || '';
  const CURRENCY_SYMBOL = dataLocale?.CURRENCY_SYMBOL || '';
  const inclusiveText = productData && productData?.inclusiveText;

  const isPreProd = process.env.ENVIRONMENT === 'preprod';

  const frameDimensions = useMemo(() => {
    return (
      productData?.specifications?.[0]?.items?.find(
        ({ name }) => name === 'Frame Dimensions With Height'
      )?.value ||
      productData?.specifications?.[0]?.items?.find(({ name }) => name === 'Frame Dimensions')
        ?.value ||
      null
    );
  }, [productData]);

  const onSelectColorOption = link => {
    odPushGA4Event('cta_click', {
      userInfo,
      platform,
      ctaName: 'color-options',
      ctaFlowAndPage: 'product-detail-page',
    });

    if (link?.length > 0 && link.includes('sg/en/')) {
      window.location.assign(`/${removeDomainName(link)}`);
    } else {
      window.location.assign(`/sg/en/${removeDomainName(link)}`);
    }
  };

  useEffect(() => {
    if (productData) {
      const client = apiClient();
      client.setHeader();
      client
        .get(`${apiPath.redis}prod:303189`)
        .then(res => {
          console.log('this is redis response ===>', res);
        })
        .catch(() => {});
    }
  }, [productData]);

  useEffect(() => {
    const exchangeMarketPrice =
      productData &&
      productData.prices &&
      productData.prices.find(price => price.name === 'Market Price');
    const exchangePrice =
      productData &&
      productData.prices &&
      productData.prices.find(price => price.name === 'Lenskart Price');

    setExchangePrice(exchangePrice);
    setExchangeMarketPrice(exchangeMarketPrice);
  }, [productData]);

  const { defaultColor, colorOptionsWithDefaultFirst } = useMemo(() => {
    const defaultColor = colorOptions.find(
      colorOption => colorOption.id === productData.id
    )?.colorHex;
    const colorOptionsWithDefaultFirst = [
      ...colorOptions.filter(colorOption => colorOption.id === productData.id),
      ...colorOptions.filter(colorOption => colorOption.id !== productData.id),
    ];
    return { defaultColor, colorOptionsWithDefaultFirst };
  }, [colorOptions, productData.id]);

  useEffect(() => {
    setSelectedColor(defaultColor);
  }, [defaultColor]);

  useEffect(() => {
    const selectedColorData = colorOptions.find(({ color }) => color === selectedColor);

    if (selectedColorData) {
      debounce(
        setColorPreviewImageUrl(
          selectedColorData.id === productData.id ? null : selectedColorData.imageUrls?.[0]
        ),
        500
      );
    }
  }, [selectedColor, colorOptions, productData.id, setColorPreviewImageUrl]);

  const renderOffers = () => {
    return (
      <>
        {productData.classification === 'eyeframe' &&
        !isGundamProduct(productData?.id) &&
        !isHarryPotterProduct(productData?.id) ? (
          <div className="product-details__second-pair-dis">
            <p className="product-details__second-pair-dis-subtitle">
              <img
                alt="Best offer for you"
                src="https://static1.lenskart.com/owndays/img/icons/bofy.webp"
              />
              Best offer for you
            </p>
            <p className="product-details__second-pair-dis-title">Get 50% off second pair</p>
            <p className="product-details__second-pair-dis-description">
              *Excluding sale and collaboration products
            </p>
          </div>
        ) : null}
      </>
    );
  };

  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowImportantNotesModal(false);
      setIsClosing(false);
    }, 300);
  };

  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  const importantNotesModal = showImportantNotesModal && (
    <div
      className={`important-notes-modal ${isClosing ? 'fade-out' : ''}`}
      onClick={handleBackdropClick}
    >
      <div className="important-notes-modal-content">
        <button
          aria-label="Close Modal Icon"
          className="important-notes-modal-content-close"
          type="button"
          onClick={handleCloseModal}
        />
        <div className="important-notes-modal-content-title">Important Notes</div>
        <ul className="important-notes-modal-content-list">
          <li>
            The key chain is distributed at random; you cannot choose which design you will receive.
          </li>
          <li>
            The novelty item giveaway will end once supplies run out, even during the pre-order
            period.
          </li>
          <li>Resale or transfer of the gift items is strictly prohibited.</li>
          <li>This campaign may be changed or ended without prior notice.</li>
        </ul>
      </div>
    </div>
  );

  const renderImportantNotes = () => {
    return (
      <div className="important-notes-container">
        <div className="important-notes-container-item">
          <div className="important-notes-container-item-title">Pre-order exclusive product</div>
          <div className="important-notes-container-item-subtitle">
            Delivery: Starts from 26th June onwards
          </div>
          <div className="important-notes-container-item-description">
            Due to production circumstances, the delivery date may be earlier or later than
            expected.
          </div>
        </div>
        <a
          className="important-notes-container-link"
          onClick={() => setShowImportantNotesModal(true)}
        >
          Important Notes
        </a>
        {importantNotesModal}
      </div>
    );
  };

  return (
    <div className="product-details">
      <ProductDetailHeading
        bardNameInfo={{ frameColour, frameType, frameShape, type, contactLensPowerFromUrl }}
        productData={productData}
      />
      <div
        className={`product-details__price ${
          productData?.offersClarity ? 'product-details__price--sale' : ''
        }`}
      >
        {productData.classification === 'eyeframe' && (
          <span className="product-details__price-eyeframe">Lens Included</span>
        )}
        <div className="product-details__price-section-wrapper">
          {productData?.offersClarity && (
            <span className="product-details__price-section-offer-heading">
              {productData?.offersClarity?.options[0].offerHeading}
            </span>
          )}
          <div className="product-details__price-section">
            <Pricing
              productDetailsPrice
              currencySymbol={currencySymbol}
              dataLocale={dataLocale}
              exchangeFreeText={exchangeFreeText}
              exchangeMarketPrice={exchangeMarketPrice}
              exchangePrice={exchangePrice}
              exchangeText={exchangeText}
              finalprice={calculateOptimalPrice(productData)}
              inclusiveText={inclusiveText}
              isExchange={isExchange}
              localeInfo={localeInfo}
              marketPrice={marketPrice}
              productOfferIdDetails={productOfferIdDetails}
            />
            {calculateOptimalPrice(productData) < marketPrice ? (
              <del className="product-details__price-section-mp">
                {`${CURRENCY_CODE}${CURRENCY_SYMBOL}${marketPrice}`}
              </del>
            ) : null}
          </div>
        </div>
      </div>
      {renderOffers()}
      {colorOptions && colorOptions.length > 0 && productData?.color && (
        <div className="product-details__colors">
          <p className="product-details__colors-title">{COLOUR}</p>
          <ColorOptions
            PDPColors
            colorOptions={colorOptionsWithDefaultFirst}
            defaultColor={defaultColor}
            selectedColor={selectedColor}
            setSelectedColor={setSelectedColor}
            onClick={onSelectColorOption}
          />
        </div>
      )}
      {productData.brandName === 'SQUID GAME × OWNDAYS' &&
        ((isPreProd && new Date() <= new Date('2025-06-27T09:59:00+08:00')) ||
          (!isPreProd &&
            new Date() >= new Date('2025-06-20T10:00:00+08:00') &&
            new Date() <= new Date('2025-06-27T09:59:00+08:00'))) &&
        renderImportantNotes()}
      {productData.classification === 'contact_lens' && (
        <ContactLensParams
          packaging={contactLensPackaging}
          powers={contactLensPowers}
          selectContactLensPowersCallback={selectContactLensPowersCallback}
        />
      )}
    </div>
  );
};

export default ProductDetailNew;
